import { type ReactNode } from 'react';

interface Props {
	title: string;
	subtitle?: string;
	actions?: ReactNode;
}

export function PageHead({ title, subtitle, actions }: Props) {
	return (
		<div className="flex items-start gap-4 mb-6">
			<div>
				<h1 className="text-[22px] font-bold leading-tight tracking-tight">{title}</h1>
				{subtitle && <p className="text-[13px] text-muted-foreground mt-0.5">{subtitle}</p>}
			</div>
			{actions && <div className="ml-auto flex gap-2">{actions}</div>}
		</div>
	);
}
